import React, { useState } from 'react';
import { AiOutlineMenu, AiOutlineQuestionCircle } from 'react-icons/ai';
import { BsFillInfoCircleFill, BsHeadset } from 'react-icons/bs';
import { CgMenuLeft, CgProfile } from 'react-icons/cg';
import { FiLogOut } from 'react-icons/fi';
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md';
import { PiCaretDown, PiCaretUp } from 'react-icons/pi';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { LoginLogo, Logo } from 'src/assets/images';
import { Button } from 'src/components';
import ButtonWithIcon from 'src/components/ButtonWithIcon';
import Title from 'src/components/title';
import useClickOutside from 'src/hooks/useClickOutside';
import { logoutAction } from 'src/redux/action/auth.action';

interface IProps {
  sideBarSwitch: boolean;
  title?: string;
  setSidebarSwitch: (val: boolean) => void;
}

const NavBar: React.FC<IProps> = ({
  sideBarSwitch,
  title,
  setSidebarSwitch,
}) => {
  const navigate = useNavigate();
  const [showNavDropDown, setShowNavDropDown] = useState<boolean>(false);
  const userData: any = window.localStorage.getItem('userInfo');
  const dispatch: any = useDispatch();
  const parseUserData = JSON.parse(userData);
  const dropdownRef = useClickOutside(() => setShowNavDropDown(false));

  const newLocal = (
    <div
      className="cursor-pointer relative flex items-center gap-4 "
      ref={dropdownRef}
    >
      <ButtonWithIcon
        icon={<BsFillInfoCircleFill size={20} style={{ color: '' }} />}
        title={'FAQ'}
        className={'text-sm'}
      />
      <ButtonWithIcon
        path={'help'}
        icon={<AiOutlineQuestionCircle size={20} />}
        title={'Help Center'}
        className={'text-xl'}
      />
      <Button
        text="9808555854"
        className="text-pure-white ring-pure-white pt-[5px] h-[29px] text-sm"
        icon={<BsHeadset size={16} />}
        variant={'outline'}
      />
    </div>
  );
  return (
    <nav
      className={`
      hidden xl:flex 
      z-50 px-8 py-3 w-full h-[53px] 
      fixed top-0 border-border-color border-b 
      bg-[#2B2B2B] text-pure-white
    `}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center space-x-3">
          <img src={LoginLogo} alt="" className="w-auto h-5" />
        </div>
        {newLocal}
      </div>
    </nav>
  );
};

export default React.memo(NavBar);
